import axios from "axios";
// export const basePath = '/proxy-api-http-buy/app-api';//本地代理
export const basePath = 'https://mpapi.partyday.vip';
// export const basePath = 'https://192.168.31.210';//本地


const request = axios.create();

// 设置请求拦截器，每次请求动态获取 token
request.interceptors.request.use(config => {
    const token = localStorage.getItem('satoken'); // 每次请求动态获取 token
    if (token) {
        config.headers['satoken'] = token;
    }
    config.headers['Content-Type'] = 'application/json';
    return config;
}, error => {
    return Promise.reject(error);
});

const http = {
    path(_path) {
        return basePath + _path;
    },
    get(path, data) {
        return request.get(this.path(path), {
            params: data
        })
    },
    post(path, data) {
        return request.post(this.path(path), data)
    }
}

export default http;